import { StatusCodes } from 'http-status-codes'
import type { ApiErrorResponse, ApiErrorType } from './types'

export class ApiOperationError extends Error {
  constructor(
    message: string,
    public readonly errorType: ApiErrorType,
  ) {
    super(message)
    this.name = 'ApiOperationError'
  }
}

export function mapHttpStatusToErrorType(status: number): ApiErrorType {
  if (status === StatusCodes.BAD_REQUEST) return 'validation_failed'
  if (status === StatusCodes.UNAUTHORIZED) return 'unauthorized'
  if (status === StatusCodes.FORBIDDEN) return 'forbidden'
  if (status === StatusCodes.NOT_FOUND) return 'not_found'
  if (status === StatusCodes.CONFLICT) return 'conflict'
  if (status >= StatusCodes.INTERNAL_SERVER_ERROR) return 'server_error'
  return 'unknown_error'
}

export function isApiErrorResponse(data: unknown): data is ApiErrorResponse {
  return (
    typeof data === 'object' &&
    data !== null &&
    'timestamp' in data &&
    'status' in data &&
    'error' in data &&
    'message' in data &&
    'path' in data
  )
}

export const ERROR_MESSAGES: Record<ApiErrorType, string> = {
  validation_failed: 'Invalid request. Please check your input.',
  unauthorized: 'Authentication failed. Please log in again.',
  forbidden: 'Access denied. You do not have permission.',
  not_found: 'The requested resource was not found.',
  conflict: 'A conflict occurred. The resource may already exist.',
  server_error: 'Server error occurred. Please try again.',
  network_error: 'Network connection failed. Please check your connection.',
  timeout: 'Request timed out. Please try again.',
  unknown_error: 'An unexpected error occurred.',
}
